import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { ENVIRONMENT } from 'shared/config';
import { FEATURE_FLAG } from 'shared/utils/constants';

const IS_PRODUCTION = process.env.ENVIRONMENT === ENVIRONMENT.PRODUCTION;
const sufix = IS_PRODUCTION ? 'prod' : 'demo';

export function useFeatureIsEnabled(feature: FEATURE_FLAG): boolean {
  const featureFlagName = `${feature}:${sufix}`;
  return useFeatureIsOn(featureFlagName);
}
